<template>
  <div class="group container">
    <div v-if="showError">
      <div class="row">エラーにより登録画面が表示できませんでした。</div>
      <div class="row">エラー番号：{{ resultState }}</div>
      <div class="row">{{ errMessage }}</div>
      <div class="row">
        <div class="mx-auto">
          <router-link tag="button" class="btn btn-lg btn-secondary" to="/">戻る</router-link>
        </div>
      </div>
    </div>
    <div v-else>Loading...</div>
  </div>
</template>

<script>
import err from '@/err'
import axios from 'axios'

export default {
  name: 'EntryMailConfirm',
  props: {
    token: String
  },
  data() {
    return {
      resultState: err.OK,
    }
  },
  computed: {
    tokenStr() {
      return this.token || ""
    },
    showError() {
      return this.resultState != err.OK
    },
    errMessage() {
      return err.desc[this.resultState]
    }
  },
  mounted() {
    window.console.log('token', this.tokenStr)
    if (this.tokenStr == '') {
      this.resultState = err.MAIL_INVALID_TOKEN
      return
    }
    if (this.tokenStr == process.env.VUE_APP_FORCE_TOKEN) {
      this.$store.dispatch("setForceEntryMode")
      this.resultState = err.OK
      let payload = {
        mail: '',
        token: this.tokenStr
      }
      this.$store.dispatch('entry/setInitialEntryData', payload)
      this.$router.push('/entry/step1')
      return
    }
    let params = new URLSearchParams()
    params.append("token", this.tokenStr)
    axios.post(process.env.VUE_APP_BASE_URL + "api/mail_confirm.asp", params)
      .then(res => {
        window.console.log('entry mail confirm result:', res.data)
        this.resultState = res.data.state
        if (this.resultState == err.OK) {
          let payload = {
            mail: res.data.mail,
            token: this.tokenStr
          }
          this.$store.dispatch('entry/setInitialEntryData', payload)
          this.$router.push('/entry/step1')
        }
      })
      .catch(e => {
        window.console.warn('error', e)
        this.resultState = err.UNKNOWN
        this.showResult = true
      })
  }
}
</script>